// principles.js

// Data model: each pair = one row with a principle + matching guideline
const pgPairs = [
  {
    principleTitle: "1. Life First",
    principleBody:
      "Everything begins with respect for the land, the plants, and the people who steward them.",
    guidelineTitle: "Guideline 1 — Voluntary Participation",
    guidelineBody:
      "All contracts are voluntary. No one is required to enter into any trade, agreement, or interaction, and no party may be coerced or pressured into a contract."
  },
  {
    principleTitle: "2. Value Over Profit",
    principleBody:
      "Value flows both ways — through seeds, knowledge, labor, materials, kindness and so many other methods. Not everything has to be exchanged for paper currency.",
    guidelineTitle: "Guideline 2 — Exchange, Not Commercial Sale",
    guidelineBody:
      "Paper currency may be used, but each transaction is treated as an agreement between people — an exchange of specific things for specific things, not a \"commercial sale\" unless explicitly agreed upon."
  },
  {
    principleTitle: "3. Regenerate, Don’t Extract",
    principleBody:
      "Wherever the network operates, the goal is to leave soil, ecosystems, and people better than we found them.",
    guidelineTitle: "Guideline 3 — No Harmful Practices",
    guidelineBody:
      "Exchanges or actions that knowingly irreversibly damage land, water, property, or community health are not allowed. Members are expected to act with regeneration and balance in mind."
  },
  {
    principleTitle: "4. Honor other's claims",
    principleBody:
      "Always honor the claims of others until evidence contradicts them.",
    guidelineTitle: "Guideline 4 — No Intentional Destruction",
    guidelineBody:
      "Any deliberate destruction of property or projects clearly tied to Lost N Found Nursery© or its members or partners can result in immediate removal from the network and, if necessary, legal action."
  },
  {
    principleTitle: "5. Clarity and Consent in Agreements",
    principleBody:
      "Every exchange is based on simple, readable terms, and voluntary consent.",
    guidelineTitle: "Guideline 5 — Clear, Private Agreements",
    guidelineBody:
      "Participants are encouraged to write out or clearly state what is being exchanged, and what each person expects in return. Disputes are handled through private conversation first, then, if a conclusion cannot be reached, they may use private arbitration. Being a member of the LostNFound Network qualifies as an agreement to handle disputes privately and respectfully, and to avoid public shaming and defamation."
  },
  {
    principleTitle: "6. Regenerative Land Ethics",
    principleBody:
      "Exchanges should help landscapes thrive, not decline.",
    guidelineTitle: "Guideline 6 — No Spreading Invasives",
    guidelineBody:
      "Plants known to be invasive in a region may not be intentionally exchanged or spread. Warnings will be given for accidental mistakes; ignoring them can result in removal from the network."
  },
  {
    principleTitle: "7. Personal Responsibility",
    principleBody:
      "Each man or woman is responsible for their own body, choices, and tools.",
    guidelineTitle: "Guideline 7 — Liability & Safety",
    guidelineBody:
      "Members acknowledge that growing, planting, visiting land, and using tools carry natural risks. A simple liability waiver in the Membership Agreement protects stewards and hosts; each member is responsible for their own safety and choices."
  },
  {
    principleTitle: "8. Leave the Network Better Than You Found It",
    principleBody:
      "Teach when you can, learn when you can, give when you can, and keep growing.",
    guidelineTitle: "Guideline 8 — Contribution",
    guidelineBody:
      "Members are encouraged to share seeds, knowledge, surplus, or support whenever they are able, so the network as a whole becomes more resilient and abundant over time."
  },
  {
    principleTitle: "9. Value determination",
    principleBody:
      "The value of plants, services, and knowledge is determined by the parties involved in each exchange, based on local context, individual needs, and personal judgement.",
    guidelineTitle: "Guideline 9 — Fair Value Exchange",
    guidelineBody:
      "Members agree to determine the value of their own items or services in a mutual negotiation, striving for fairness and respect rather than strict market pricing."
  },
];

// Render into the DOM
function renderPrinciplesAndGuidelines() {
  const grid = document.getElementById("pgGrid");
  if (!grid) return; // In case this script loads on a page without the section

  pgPairs.forEach((pair) => {
    const row = document.createElement("div");
    row.className = "pg-row";

    const principleCol = document.createElement("div");
    principleCol.className = "pg-col pg-col-principle";
    principleCol.innerHTML = `
      <h3 class="pg-heading">${pair.principleTitle}</h3>
      <p class="pg-text">${pair.principleBody}</p>
    `;

    const guidelineCol = document.createElement("div");
    guidelineCol.className = "pg-col pg-col-guideline";
    guidelineCol.innerHTML = `
      <h3 class="pg-heading">${pair.guidelineTitle}</h3>
      <p class="pg-text">${pair.guidelineBody}</p>
    `;

    row.appendChild(principleCol);
    row.appendChild(guidelineCol);
    grid.appendChild(row);
  });
}

// Run on load
document.addEventListener("DOMContentLoaded", renderPrinciplesAndGuidelines);
